import React from 'react';

import { Pagination } from 'antd';

/**
 * Reusable Pagination component that works with usePaginationWithFirestore hook
 *
 * @param {Object} paginationState - State from usePaginationWithFirestore hook
 * @param {Object} options - Additional pagination options
 */
const PaginationWithFirestore = ({ paginationState, options = {} }) => {
  const {
    currentPage,
    estimatedTotal,
    totalItems,
    handlePageChange,
    loading,
    hasMoreData,
    pageSize: statePageSize,
  } = paginationState;

  const {
    // pageSize now lives in the hook (single source of truth). `options.pageSize`
    // is only a fallback for older callers whose state doesn't expose it yet.
    pageSize: optionPageSize = 10,
    showSizeChanger = false,
    pageSizeOptions,
    showTotal: customShowTotal,
    ...otherProps
  } = options;

  const pageSize = statePageSize ?? optionPageSize;

  // Hide pagination when there is nothing to show
  if (totalItems === 0) {
    return null;
  }

  // Range text uses loaded count; "+" indicates more may exist in Firestore
  const defaultShowTotal = (total, range) => {
    const actualEnd = Math.min(range[1], totalItems);
    return `${range[0]}-${actualEnd} de ${totalItems}${hasMoreData ? '+' : ''} elementos`;
  };

  return (
    <div
      className="gx-flex-row gx-justify-content-center gx-mt-2"
      data-testid="pagination"
    >
      <Pagination
        current={currentPage}
        onChange={handlePageChange}
        onShowSizeChange={handlePageChange}
        total={estimatedTotal}
        pageSize={pageSize}
        showSizeChanger={showSizeChanger}
        pageSizeOptions={pageSizeOptions}
        disabled={loading}
        showTotal={!customShowTotal ? false : customShowTotal || defaultShowTotal}
        {...otherProps}
      />
    </div>
  );
};

export default PaginationWithFirestore;
